<script lang="ts">
  interface Props {
    active?: boolean;
    number?: number;
    class?: string;
    children?: import("svelte").Snippet;
  }

  let { active = false, number = null, class: className, children }: Props = $props();
</script>

<div class="breadcrumb overflow-visible {className}">
  {#if number}
    <span class="breadcrumb-text">{number + ". "}{@render children?.()}</span>
    <span
      data-label={number + ". "}
      class="breadcrumb-box {active ? 'bg-Violet400' : 'bg-Neutral300 text-Neutral700'}"
    ></span>
  {:else}
    <span class="breadcrumb-box {active ? 'bg-Violet400' : 'bg-Neutral300 text-Neutral700'}"></span>
  {/if}
</div>
